module.exports = __webpack_public_path__ + "img/20201101_161050.c22af0a0.jpg";